import React, { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Quotes, ArrowLeft, ArrowRight } from "@phosphor-icons/react";
import { TESTIMONIALS } from "../data/content";

const Testimonials = () => {
  const [i, setI] = useState(0);
  const len = TESTIMONIALS.length;

  useEffect(() => {
    const t = setInterval(() => setI((p) => (p + 1) % len), 7000);
    return () => clearInterval(t);
  }, [len]);

  const prev = () => setI((p) => (p - 1 + len) % len);
  const next = () => setI((p) => (p + 1) % len);

  const t = TESTIMONIALS[i];

  return (
    <section
      className="py-24 md:py-32 bg-secondary text-secondary-foreground relative overflow-hidden"
      data-testid="testimonials-section"
    >
      <div className="absolute inset-0 grain opacity-50 pointer-events-none" />
      <div className="container relative grid lg:grid-cols-12 gap-10 items-center">
        <div className="lg:col-span-4">
          <div className="overline text-primary mb-4">— Testimonial</div>
          <h2 className="font-display font-bold tracking-tight text-3xl md:text-5xl leading-[1.05]">
            What partners
            <br />say about us.
          </h2>
          <div className="mt-10 flex gap-3">
            <button
              onClick={prev}
              data-testid="testimonial-prev"
              aria-label="Previous testimonial"
              className="grid place-items-center w-12 h-12 rounded-full border border-secondary-foreground/30 hover:border-primary hover:text-primary transition-colors"
            >
              <ArrowLeft size={18} weight="bold" />
            </button>
            <button
              onClick={next}
              data-testid="testimonial-next"
              aria-label="Next testimonial"
              className="grid place-items-center w-12 h-12 rounded-full border border-secondary-foreground/30 hover:border-primary hover:text-primary transition-colors"
            >
              <ArrowRight size={18} weight="bold" />
            </button>
          </div>
        </div>

        <div className="lg:col-span-8">
          <Quotes
            size={56}
            weight="fill"
            className="text-primary mb-6 opacity-90"
          />
          <AnimatePresence mode="wait">
            <motion.div
              key={i}
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0, y: -20 }}
              transition={{ duration: 0.5 }}
            >
              <p className="font-display font-medium text-2xl md:text-4xl leading-tight tracking-tight">
                "{t.quote}"
              </p>
              <div className="mt-8 flex items-center gap-4">
                <div className="grid place-items-center w-12 h-12 rounded-full bg-primary text-primary-foreground font-display font-bold">
                  {t.name.charAt(0)}
                </div>
                <div>
                  <div className="font-medium">{t.name}</div>
                  <div className="overline text-secondary-foreground/60">
                    {t.company}
                  </div>
                </div>
              </div>
            </motion.div>
          </AnimatePresence>

          <div className="mt-8 flex gap-2">
            {TESTIMONIALS.map((_, idx) => (
              <button
                key={idx}
                onClick={() => setI(idx)}
                aria-label={`Go to testimonial ${idx + 1}`}
                className={`h-1.5 rounded-full transition-all ${
                  idx === i
                    ? "w-10 bg-primary"
                    : "w-4 bg-secondary-foreground/20 hover:bg-secondary-foreground/40"
                }`}
              />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
